import styled from 'styled-components';

export const Option = styled.div`
  position: relative;
`;

export const Description = styled.div`
  position: absolute;
  right: 0;
  top: 0;
`;

export const DescriptionPill = styled.div`
  background-color: #f5f5f5;
  border-radius: 2px;
  border: 1px solid #e0e0e0;
  color: rgba(0, 0, 0, 0.87);
  display: inline-block;
  font-size: 0.9em;
  line-height: 1.4;
  vertical-align: top;
  padding-left: 5px;
  padding-right: 5px;
`;

export const BluePill = styled.div`
  background-color: #00b9af;
  border-radius: 3px;
  color: rgb(255, 255, 255);
  display: inline-block;
  font-size: 0.9em;
  line-height: 1.4;
  vertical-align: top;
  padding-left: 5px;
  padding-right: 5px;
`;

export const WarningPill = styled.div`
  background-color: ${(props) => props.theme.colors.notificationWarning};
  border-radius: 3px;
  color: rgb(255, 255, 255);
  display: inline-block;
  font-size: 0.9em;
  line-height: 1.4;
  vertical-align: top;
  padding-left: 5px;
  padding-right: 5px;
`;

export const PartNumberPill = styled.div`
  background-color: #00b9af;
  border-radius: 2px;
  border: 1px solid #e0e0e0;
  color: white;
  display: inline-block;
  font-size: 1em;
  font-weight: bold;
  line-height: 1.4;
  vertical-align: top;
  padding-left: 5px;
  padding-right: 5px;

  overflow: hidden;
  max-width: 15ch;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: right;
`;
